/* eslint-disable prettier/prettier */

import React, { FunctionComponent, useEffect, useRef } from 'react'

export interface EasySoftwareEmbeddedCodeType {
  contentType: 'EasySoftwareEmbeddedCode'
  contentItemId: string
  embeddedCodeShortCode: {
    html: string
  }
  embeddedCodeType: 'head' | 'body' | 'html'
}

export interface EasySoftwareDangerousEmbeddedCodeType {
  contentType: 'EasySoftwareDangerousEmbeddedCode'
  contentItemId: string
  dangerousEmbeddedCodeSourceCode: {
    html: string
  }
  dangerousEmbeddedCodeType: EmbeddedCodeType
}

type EasySoftwareEmbeddedCode =
  | EasySoftwareEmbeddedCodeType
  | EasySoftwareDangerousEmbeddedCodeType

type EmbeddedCodeType = 'head' | 'body' | 'html'

const rootClass = `embeddedcode`

const EasySoftwareEmbeddedCode: FunctionComponent<EasySoftwareEmbeddedCode> = (
  props
) => {
  let embeddedCode: string
  let embeddedCodeType: EmbeddedCodeType

  switch (props.contentType) {
    case `EasySoftwareEmbeddedCode`:
      embeddedCodeType = props.embeddedCodeType
      embeddedCode = props.embeddedCodeShortCode?.html
      break
    case `EasySoftwareDangerousEmbeddedCode`:
      embeddedCodeType = props.dangerousEmbeddedCodeType
      embeddedCode = props.dangerousEmbeddedCodeSourceCode?.html
      break
  }

  if (typeof embeddedCode === `string`) {
    switch (embeddedCodeType) {
      case `head`:
        if (typeof document === `undefined`) return null
        const frag = document
          .createRange()
          .createContextualFragment(embeddedCode.trim())
        if (frag === null) {
          console.warn(
            `EmbeddedCode id=${props.contentItemId} has null Fragment`
          )
        } else {
          document.head.appendChild(frag)
        }
        return null
      case `body`:
        useEffect(() => {
          const frag = document
            .createRange()
            .createContextualFragment(embeddedCode.trim())
          if (frag === null) {
            console.warn(
              `EmbeddedCode id=${props.contentItemId} has null Fragment`
            )
          } else {
            document.body.appendChild(frag)
          }
        }, [])
      case `html`:
        return (
          <div
            className={rootClass}
            id={props.contentItemId}
            dangerouslySetInnerHTML={{ __html: embeddedCode }}
          ></div>
        )
      default:
        console.warn(
          `EmbeddedCode id=${props.contentItemId} has empty field "embeddedCodeType"!`
        )
        return null
    }
  }
  console.warn(`EmbeddedCode id=${props.contentItemId} is empty!`)
  return null
}

export default EasySoftwareEmbeddedCode
